import { fetchOneEntry } from "@builder.io/sdk-vue";

export default defineNuxtRouteMiddleware(async (to) => {
    if (!import.meta.server) return;

    const apiKey = useRuntimeConfig().public.builderApiKey;
    
    try {
        const fetchedRedirectionRule: any = await fetchOneEntry({
            apiKey,
            model: "redirection",
            query: {
                data: {
                    from: to.fullPath
                }
            }
        })

        let redirectionCode = 301;
        if (fetchedRedirectionRule && fetchedRedirectionRule.data && fetchedRedirectionRule.data.to) {
            if (fetchedRedirectionRule.data.temporaryRedirect) redirectionCode = 302;
            return navigateTo(fetchedRedirectionRule.data.to, { redirectCode: redirectionCode })
        }

    } catch (error) {
        let errorMeta = { productRedirectError: true }
        const nuxtApp = tryUseNuxtApp()
        if (nuxtApp && typeof nuxtApp.$customClientErrorHandler === "function") {
            nuxtApp.$customClientErrorHandler(
                error,
                "high",
                "Builder Error - Failed to fetch redirect routes",
                errorMeta
            );
        }
    }
})